import { render, staticRenderFns } from "./vdlist.vue?vue&type=template&id=1a9bf544&scoped=true&"
import script from "./vdlist.vue?vue&type=script&lang=js&"
export * from "./vdlist.vue?vue&type=script&lang=js&"
import style0 from "./vdlist.vue?vue&type=style&index=0&id=1a9bf544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9bf544",
  null
  
)

export default component.exports